import { useEffect, useState } from 'react';

type ToastMessageProps = {
    message: string;
    timeout?: number;
}

export function ToastMessage({ message, timeout = 3000 }: ToastMessageProps) {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsVisible(false);
        }, timeout);

        return () => {
            clearTimeout(timeoutId);
        };
    }, []);

    return isVisible ?(
        <div
            className={
                'pointer-events-auto flex w-full max-w-2xl flex-row items-center gap-3 rounded-lg bg-inverse-surface p-4 text-on-inverse-surface shadow-md'
            }
        >
            {message}
        </div>
    ) : null;
}
